import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';

import { DropdownObjectType } from '../../../shared/types';
import { TAXONOMY_FILTER_VALUES } from '../taxonomy.constants';

@Component({
  selector: 'taxonomy-dropdown',
  standalone: true,
  imports: [CommonModule, MatMenuModule],
  templateUrl: './taxonomy-dropdown.component.html',
  styleUrl: './taxonomy-dropdown.component.scss',
})
export class TaxonomyDropdownComponent {
  @Output() onItemSelect = new EventEmitter<DropdownObjectType>();
  selectedValue: DropdownObjectType | undefined | null = TAXONOMY_FILTER_VALUES[0];
  contentList: Array<DropdownObjectType> = TAXONOMY_FILTER_VALUES;
  dropdownOpened: boolean = false;

  handleItemSelect = (event: MouseEvent, item: DropdownObjectType) => {
    this.selectedValue = item;
    if (this.onItemSelect) {
      this.onItemSelect.emit(item);
    }
  };

  onMatMenuClosed() {}

  handleButtonClick = (event: MouseEvent) => {
    this.dropdownOpened = !this.dropdownOpened;
  };
}
